import BrandHeroBlock from '@/blocks/BrandHeroBlock';
import BreadcrumbsBlock from '@/blocks/BreadcrumbsBlock';
import Prose from '@/components/Prose';
import { MEDIA_URL, REVALIDATE_TIME_IN_SEC } from '@/constants/env';
import { fadeIn } from '@/constants/motions';
import { pages } from '@/content';
import mainLayout from '@/graphql/queries/mainLayout';
import page from '@/graphql/queries/page';
import FullWidthLayout from '@/layouts/FullWidthLayout';
import graphql from '@/lib/graphql';
import { motion } from 'framer-motion';
import Markdown from 'react-markdown';

export default function CsrPage({ mainLayout, page }) {
  const attributes = page?.attributes || {};
  const contentSection = attributes.contentSection || [];
  const metaData = attributes.metaData || {};
  return (
    <FullWidthLayout mainLayout={mainLayout} metaData={metaData}>
      {contentSection[0]?.heroImage?.data?.attributes?.url ? (
        <BrandHeroBlock
          image={MEDIA_URL.concat(contentSection[0].heroImage.data.attributes.url)}
          title={contentSection[0].heroTitle}
        />
      ) : null}
      <BreadcrumbsBlock items={[pages.home, pages.about, pages.csr]} />
      <motion.section
        className="my-16 px-4"
        initial="hidden"
        transition={{
          ...fadeIn.transition,
          delay: 0.4,
        }}
        variants={fadeIn}
        viewport={fadeIn.viewport}
        whileInView="visible"
      >
        <div className="container-screen">
          <Prose className="max-w-full prose-headings:mb-4 prose-headings:font-normal prose-p:text-justify prose-img:inline-block">
            <Markdown>{contentSection[1]?.editorContent || ''}</Markdown>
          </Prose>
        </div>
      </motion.section>
    </FullWidthLayout>
  );
}

export async function getStaticProps() {
  const { data: mainLayoutData } = await graphql(mainLayout);

  const { data: pageData } = await graphql(page, { slug: 'csr' });

  return {
    props: {
      mainLayout: mainLayoutData.mainLayout.data,
      page: pageData.pages.data[0],
    },
    revalidate: parseInt(REVALIDATE_TIME_IN_SEC), // In seconds
  };
}
